import React, { createContext, useState, ReactNode } from 'react';

interface BackendContextType {
  backend: any;
  setBackend: (data: any) => void;
}

export const BackendContext = createContext<BackendContextType>({
  backend: undefined,
  setBackend: () => {}, 
});

interface BackendProviderProps {
  children: ReactNode;
}

export function BackendProvider({ children }: BackendProviderProps) {
  const [backend, setBackend] = useState<any>();

  const value = {
    backend,
    setBackend,
  };

  return <BackendContext.Provider value={value}>{children}</BackendContext.Provider>;
}
